// frontend/src/sections/Home/Features/Features.jsx

import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/common/Icon";
import Reveal from "../../../components/common/Reveal";
import { FEATURES } from "./constance";

const FEATURE_LINKS = [
  "/clubs",
  "/players",
  "/competitions",
  "/news",
  "/about",
  "/contact",
];

const FEATURE_ACCENTS = [
  {
    icon: "from-emerald-400 to-emerald-600",
    soft: "bg-emerald-50 text-emerald-600",
    hover: "group-hover:bg-emerald-500 group-hover:text-white",
    glow: "bg-emerald-400/10",
  },
  {
    icon: "from-blue-400 to-blue-600",
    soft: "bg-blue-50 text-blue-600",
    hover: "group-hover:bg-blue-500 group-hover:text-white",
    glow: "bg-blue-400/10",
  },
  {
    icon: "from-amber-400 to-orange-500",
    soft: "bg-amber-50 text-amber-600",
    hover: "group-hover:bg-amber-500 group-hover:text-white",
    glow: "bg-amber-400/10",
  },
  {
    icon: "from-rose-400 to-rose-600",
    soft: "bg-rose-50 text-rose-600",
    hover: "group-hover:bg-rose-500 group-hover:text-white",
    glow: "bg-rose-400/10",
  },
  {
    icon: "from-lime-400 to-cyan-600",
    soft: "bg-lime-50 text-cyan-600",
    hover: "group-hover:bg-lime-500 group-hover:text-white",
    glow: "bg-lime-400/10",
  },
  {
    icon: "from-violet-400 to-violet-600",
    soft: "bg-violet-50 text-violet-600",
    hover: "group-hover:bg-violet-500 group-hover:text-white",
    glow: "bg-violet-400/10",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      className="relative overflow-hidden py-20 sm:py-24 lg:py-28"
    >
      {/* Background decoration */}
      <div className="pointer-events-none absolute -right-40 top-10 h-96 w-96 rounded-full bg-emerald-400/10 blur-3xl" />
      <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-blue-400/10 blur-3xl" />

      <div
        className="pointer-events-none absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            "linear-gradient(#0B1F17 1px, transparent 1px), linear-gradient(90deg, #0B1F17 1px, transparent 1px)",
          backgroundSize: "42px 42px",
        }}
      />

      <div className="container-page relative">
        {/* Section header */}
        <div className="mx-auto max-w-3xl text-center">
          <div className="section-eyebrow">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
            </span>

            امکانات سامانه
          </div>

          <h2 className="section-title mt-5">
            همه‌ چیز برای
            <span className="block text-gradient">
              فوتبال حرفه‌ای شهرستان پاوه
            </span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-sm leading-8 text-slate-500 sm:text-base">
            باشگاه‌ها، بازیکنان، مسابقات، اخبار و رویدادهای فوتبال شهرستان پاوه را در
            یک سامانه مدرن، سریع و یکپارچه دنبال کنید.
          </p>
        </div>

        {/* Feature cards */}
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => {
            const accent =
              FEATURE_ACCENTS[index % FEATURE_ACCENTS.length];

            const href = FEATURE_LINKS[index] || "/";

            return (
              <Reveal key={`${feature.title}-${index}`} delay={index * 70}>
              <Link
                to={href}
                className="glass group relative block min-h-[245px] overflow-hidden rounded-[2rem] p-7 transition-all duration-500 hover:-translate-y-2 hover:shadow-card-hover"
              >
                {/* Card glow */}
                <div
                  className={[
                    "pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full blur-3xl transition-all duration-500",
                    accent.glow,
                    "group-hover:scale-150",
                  ].join(" ")}
                />

                {/* Top accent */}
                <div className="absolute inset-x-0 top-0 h-1 origin-right scale-x-0 bg-gradient-to-l from-emerald-400 to-floodlight transition-transform duration-500 group-hover:scale-x-100" />

                <div className="relative flex h-full flex-col">
                  {/* Icon + arrow */}
                  <div className="flex items-start justify-between">
                    <div
                      className={[
                        "grid h-14 w-14 place-items-center rounded-[1.2rem] transition-all duration-300",
                        accent.soft,
                        accent.hover,
                        "group-hover:-translate-y-1 group-hover:shadow-lg",
                      ].join(" ")}
                    >
                      <Icon
                        name={feature.icon}
                        className="h-7 w-7 transition-transform duration-300 group-hover:scale-110"
                      />
                    </div>

                    <div className="grid h-10 w-10 place-items-center rounded-full bg-white/80 text-slate-400 transition-all duration-300 group-hover:bg-ink group-hover:text-floodlight">
                      <Icon
                        name="arrowLeft"
                        className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-0.5"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="mt-6">
                    <h3 className="text-lg font-black text-[#0B1F17] transition-colors duration-300 group-hover:text-emerald-700">
                      {feature.title}
                    </h3>

                    <p className="mt-3 line-clamp-3 text-sm leading-7 text-slate-500">
                      {feature.desc || feature.description}
                    </p>
                  </div>

                  {/* Bottom link */}
                  <div className="mt-auto flex items-center gap-1.5 pt-5 text-xs font-black text-slate-300 transition-colors duration-300 group-hover:text-emerald-600">
                    مشاهده اطلاعات
                    <Icon
                      name="arrowLeft"
                      className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-x-1"
                    />
                  </div>
                </div>
              </Link>
              </Reveal>
            );
          })}
        </div>

        {/* Bottom highlight */}
        <div className="accent-card mt-10 flex flex-col items-center justify-between gap-4 rounded-[2rem] px-6 py-6 sm:flex-row sm:px-8">
          <div className="flex items-center gap-3">
            <div className="relative z-10 grid h-12 w-12 shrink-0 place-items-center rounded-full bg-ink text-floodlight shadow-lg">
              <Icon name="trophy" className="h-5 w-5" />
            </div>

            <div>
              <p className="relative z-10 text-base font-black text-ink">
                همه اطلاعات فوتبال شهر، یکجا
              </p>

              <p className="relative z-10 mt-0.5 text-xs text-ink/65">
                اطلاعات به‌روز باشگاه‌ها، مسابقات و اخبار رسمی
              </p>
            </div>
          </div>

          <Link
            to="/competitions"
            className="relative z-10 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-xs font-black text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-ink-800 hover:shadow-xl"
          >
            شروع مشاهده
            <Icon name="arrowLeft" className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}